import * as React from "react";
import { cn } from "../../lib/cn";

export const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn("bg-muted/60 rounded animate-pulse", className)}
      {...props}
    />
  )
);
Skeleton.displayName = "Skeleton";
